<script setup>
/*
 * Butikkernes egne kampagnesider.
 *
 * Med soegning og sortering, som i edbpriser — et gitter paa tredive
 * logoer er ikke til at finde rundt i uden.
 */
import { computed, ref } from 'vue';
import { retailerLogoUrl } from '@/Utils/retailerLogo';

const props = defineProps({ data: { type: Object, required: true } });

const soeg = ref('');
const sorter = ref('');

const synlige = computed(() => {
    let l = [...(props.data.links || [])];

    if (soeg.value.trim()) {
        const q = soeg.value.trim().toLowerCase();
        l = l.filter((x) => (x.navn || '').toLowerCase().includes(q));
    }

    if (sorter.value === 'navn') l.sort((a, b) => a.navn.localeCompare(b.navn, 'da'));
    if (sorter.value === 'navn_omvendt') l.sort((a, b) => b.navn.localeCompare(a.navn, 'da'));

    return l;
});
</script>

<template>
    <p v-if="!(data.links || []).length" class="text-secondary small mb-0">
        Ingen butikker tilføjet endnu.
    </p>

    <div v-else>
        <!--
            Soeg og sortering vises kun naar der er nok butikker til at det
            giver mening. Med otte logoer er to tomme kontroller mere
            stoej end hjaelp — de stod og flagrede oeverst til hoejre.
        -->
        <div v-if="(data.links || []).length >= 12" class="vaerktoej">
            <label class="vaerktoej__felt">
                <span class="visuelt-skjult">Find butik</span>
                <input v-model="soeg" type="search" class="form-control form-control-sm" placeholder="Find butik" />
            </label>
            <label class="vaerktoej__felt">
                <span class="visuelt-skjult">Sortering</span>
                <select v-model="sorter" class="form-select form-select-sm">
                    <option value="">Standard</option>
                    <option value="navn">Navn (A → Å)</option>
                    <option value="navn_omvendt">Navn (Å → A)</option>
                </select>
            </label>
        </div>

        <div class="logo-gitter">
            <a v-for="(l, i) in synlige" :key="i" :href="l.url" class="logo-felt" target="_blank" rel="nofollow sponsored noopener">
                <img v-if="l.logo" :src="retailerLogoUrl(l.logo)" :alt="`${l.navn} logo`" loading="lazy" />
                <span v-else>{{ l.navn }}</span>
            </a>
        </div>

        <p v-if="!synlige.length" class="text-secondary small mt-2 mb-0">Ingen butikker matcher.</p>
    </div>
</template>

<style scoped>
.vaerktoej { display: flex; flex-wrap: wrap; gap: .5rem; justify-content: flex-end; margin-bottom: .75rem; }
.vaerktoej__felt { max-width: 12rem; }
.visuelt-skjult {
    position: absolute; width: 1px; height: 1px; padding: 0; margin: -1px;
    overflow: hidden; clip: rect(0, 0, 0, 0); white-space: nowrap; border: 0;
}
.logo-gitter { display: grid; gap: .75rem; grid-template-columns: repeat(auto-fill, minmax(8rem, 1fr)); }
.logo-felt {
    display: flex; align-items: center; justify-content: center;
    border: 1px solid var(--pc-border); border-radius: var(--pc-radius);
    padding: .75rem; aspect-ratio: 16 / 9;
    /*
     * HVID UANSET TEMA. Butikslogoer er tegnet til lys baggrund — de
     * fleste er moerk tekst paa gennemsigtigt — saa en moerk flise goer
     * dem usynlige. Det er ikke en tema-fejl, det er logoernes vilkaar.
     */
    background: #fff;
    text-decoration: none; color: inherit; font-size: .85rem; text-align: center;
}
.logo-felt:hover { border-color: var(--pc-accent); }
.logo-felt img { max-width: 100%; max-height: 100%; object-fit: contain; }
</style>
